<script>
import { getChartDataForFinancialPeriod } from '../../api'
// Components
import { baseDonutCmp } from '../baseDonutCmp'

export default {
  provide: {
    chartName: 'share-per-vendor'
  },

  ...baseDonutCmp(getChartDataForFinancialPeriod)
}
</script>
